import React from 'react';
import { Switch } from "react-router-dom";
//import PanelRoute from 'utils/lnk-panel/route';

class LnkRoutes extends React.Component {
  render() {
    return (
      <Switch>
      </Switch>
    )
  }
}

export default LnkRoutes;
